import React from 'react';
import { string, func } from 'prop-types';
import {
  Button,
  DrawerBody,
  DrawerFooter,
  Alert,
  Typography
} from '@one-thd/sui-atomic-components';

import { GENERIC_ERROR } from '../shared/Constants';

export const ErrorDrawer = ({ message, onClose }) => {

  return (
    <>
      <DrawerBody>
        <Alert status="error">
          <Typography>Error</Typography>
          {message || GENERIC_ERROR}
        </Alert>
      </DrawerBody>
      <DrawerFooter>
        <Button
          fullWidth
          variant="primary"
          onClick={onClose}
        >
          OK
        </Button>
      </DrawerFooter>
    </>
  );
};

ErrorDrawer.propTypes = {
  message: string,
  onClose: func.isRequired,
};

ErrorDrawer.defaultProps = {
  message: null
};

ErrorDrawer.displayName = 'AddToQuoteErrorDrawer';